import { Stack } from '@mui/material';
import { ReactComponent as StreamingTypeIcon } from 'new/components/assets/flowIconStreaming.svg';
import { ReactComponent as CDCTypeIcon } from 'new/components/assets/flowTypeCDC.svg';
import { ReactComponent as ELTTypeIcon } from 'new/components/assets/flowTypeELT.svg';
import { ReactComponent as InMemoryIcon } from 'new/components/assets/flowTypeInMemory.svg';
import { ReactComponent as ReplicationIcon } from 'new/components/assets/flowTypeReplication.svg';
import { ReactComponent as SparkIcon } from 'new/components/assets/flowTypeSpark.svg';
import { ReactComponent as RAGIcon } from 'new/components/assets/flowTypeRAG.svg';
import { ReactComponent as APIServerIcon } from 'new/components/icons/fi-rr-browser.svg';
import Typography from 'new/elements/TypographySupport';
import React from 'react';

const flowTypes = {
  replication: {
    name: 'REPLICATION',
    Icon: ReplicationIcon,
  },
  cdc: {
    name: 'DB-CDC',
    Icon: CDCTypeIcon,
  },
  elt: {
    name: 'ELT',
    Icon: ELTTypeIcon,
  },
  streaming: {
    name: 'Flex-Flow',
    Icon: StreamingTypeIcon,
  },
  rag: {
    name: 'RAG-Flow',
    Icon: RAGIcon,
  },
  spark: {
    name: 'SPARK ETL',
    Icon: SparkIcon,
  },
  in_memory: {
    name: 'Direct-Flow',
    Icon: InMemoryIcon,
  },
  custom: {
    name: 'BYO Flow',
    Icon: InMemoryIcon,
  },
  api_server: {
    name: 'API Server',
    Icon: APIServerIcon,
  },
};

const FlowTypeIcon = ({ data, className = '' }) => {
  const { name, Icon } = flowTypes[data.flow_type] || flowTypes.streaming;

  return (
    <Stack
      data-testid={`flow-type-${data.flow_type}`}
      className={className}
      gap="4px"
      direction="row"
      alignItems="center"
    >
      <Icon width="16px" height="16px" style={{ fill: 'var(--color-greyscale-600)' }} />
      <Typography sx={{ textWrap: 'nowrap' }} color="basic" variant="overline">
        {name}
      </Typography>
    </Stack>
  );
};

export default FlowTypeIcon;
